// extracted by mini-css-extract-plugin
export default {"container":"Nfts_container__9FtvI"};